import { useNavigate, useParams } from 'react-router-dom';
import { CircularProgress, Stack } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useGetOrganizationHandler } from '../dataHandlers/getOrganizationHandler';
import { useMutateOrganizationHandler } from '../dataHandlers/mutateOrganizationHandler';
import OrganizationForm from '../components/OrganizationForm';

export default function OrganizationEditPage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { id } = useParams();
  const onOrganizationEdited = () => {
    navigate('/organizations');
  };

  function handleCancel() {
    return navigate('/organizations');
  }

  const { organization, isLoading: isLoadingData } = useGetOrganizationHandler(id);
  const { onSubmit, error, isPending } = useMutateOrganizationHandler({ onSuccess: onOrganizationEdited });

  // Reset isSubmitting when mutation completes
  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const handleSubmit = async (payload) => {
    onSubmit(payload, true);
  };

  if (isLoadingData || !organization) return <CircularProgress />;

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <OrganizationForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        initialData={organization}
        edit={true}
        apiErrors={error}
        isLoading={isPending || isLoadingData || isSubmitting}
      ></OrganizationForm>
    </Stack>
  );
}
